import "autocompleter";

(function ($) {
    $(function () {
        let cache = {};
        let container = document.createElement("div");
        let $container = $(container);
        let $loading = $('<svg class="autocomplete__loading" xmlns="http://www.w3.org/2000/svg" width="80" height="80" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100">\n' +
            '    <circle cx="50" cy="50" r="30" fill="none" stroke="#424A33" stroke-width="4">\n' +
            '        <animateTransform attributeName="transform" dur="2s" keyTimes="0;0.5;1" repeatCount="indefinite" type="rotate" values="0 50 50;180 50 50;720 50 50"/>\n' +
            '        <animate attributeName="stroke-dasharray" dur="2s" keyTimes="0;0.5;1" repeatCount="indefinite" values="75 169.65;150 150;75 169.65"/>\n' +
            '    </circle>\n' +
            '</svg>');

        $(document).on('click', '[data-open-modal="search"]', function (e) {
            $('#search-input__mobile').get(0).focus({preventScroll: true});
        });
        $(".navigation__search-input").each(function () {

            let input = this;
            let $input = $(this);

            function initAutocomplete() {

                let $form = $input.closest('form');
                let block_submit = false;
                let last_ajax;
                let $wrap = $input.closest('.navigation__search');
                let isMobile = true;
                let $desktop_search = $('.navigation__search--desktop');
                if ($wrap.hasClass('navigation__search--desktop')) {
                    isMobile = false;
                } else {
                    $input.on('blur', function (e) {
                        e.stopImmediatePropagation();
                    })
                }
                $form.on('submit', function (e) {
                    if (block_submit) {
                        e.preventDefault();
                    }
                })
                $form.on('click', '.navigation__search-reset', function (e) {
                    if ($input.val() === '') {
                        // $('.mobile-search').fadeOut(300);
                    } else {
                        $input.val('');
                        $input.focus();
                    }
                });


                function overlayShow() {
                    // setTimeout(() => {
                    // 	$wrap.addClass('--open');
                    // }, 1)
                    setTimeout(() => {
                        $wrap.addClass('--open');
                        $('body').addClass('overflow_hidden');
                    }, 1)
                    setTimeout(function () {
                        $wrap.addClass('--transition');
                    }, 200);
                }

                function overlayHide() {
                    // $wrap.removeClass('--open');

                    $wrap.removeClass('--open');
                    $wrap.removeClass('--transition');
                    $('body').removeClass('overflow_hidden');
                }

                $wrap.click(function (e) {
                    // console.log(e.target)
                    if ($(e.target).hasClass('navigation__search')) {
                        // overlayHide()
                    }
                })

                $('.mobile-search__reset').click(function (e) {
                    // overlayHide()
                })

                $desktop_search.on('click', function (e) {
                    // if ($wrap.hasClass('--open')) {
                    // 	console.log(e.target);
                    // if ($(e.target).closest('.navigation__search-open--desktop').length === 0) {
                    // 	console.log('fasd');
                    // 	overlayHide();
                    // }
                    if ($wrap.hasClass('--open')) {
                        if ($(e.target).hasClass('navigation__search')) {
                            overlayHide();
                        }
                    } else {
                        overlayShow();
                        setTimeout(function () {
                            $("#search-input__desktop").focus();
                        }, 10)
                    }
                });

                let $window = $(window);

                function update_autocomplete() {
                    return autocomplete({
                        input: input,
                        minLength: 1,
                        disableAutoSelect: true,
                        container: container,
                        emptyMsg: $input.data('empty-msg'),
                        debounceWaitMs: 200,
                        showOnFocus: true,
                        customize: function (input, inputRect, container, maxHeight) {
                            if ($container.parent().get(0) !== $wrap.get(0)) {
                                $wrap.append(container);
                            }
                            container.style.top = '';
                            container.style.width = '';
                            container.style.maxHeight = ($window.height() - container.getBoundingClientRect().top) - 16 + 'px';
                        },
                        // preventSubmit: true,
                        onSelect: function (item, input) {
                            if (typeof item.name !== "undefined") {
                                input.value = item.name;
                            }
                            if (typeof item.link !== "undefined") {
                                block_submit = true;
                                window.location.href = item.link;
                            } else {
                                $(input).submit();
                            }
                        },
                        renderGroup: function (groupName, currentValue) {
                            let $group = $('<div class="autocomplete__group">' + groupName + '</div>');
                            return $group.get(0);
                        },
                        render: function (item, currentValue) {
                            return $(item.html).get(0);
                        },
                        fetch: function (text, update) {
                            if (!text) {
                                update(null);
                                return;
                            }
                            var term = text.toLowerCase();


                            if (term in cache) {
                                update(cache[term]);
                                return;
                            }
                            $wrap.append($container);
                            $container.html($loading);

                            let current_ajax = last_ajax = gp_ajax({
                                url: $form.attr('action'),
                                type: "get",
                                dataType: 'json',
                                data: {
                                    search: term,
                                    autocomplete: '1',
                                    'gp-ajax': 'autocomplete',
                                }
                            }).done(function (response, textStatus, jqXHR) {
                                cache[term] = response.data.search_result;
                                if (last_ajax === current_ajax) {
                                    update(response.data.search_result);
                                }
                            }).fail(function () {
                                if (last_ajax === current_ajax) {
                                    update([]);
                                }
                            });
                        }
                    })
                }

                let autocomplete_instance;

                function update() {
                    if ($desktop_search.is(':visible')) {
                        if (isMobile) {
                            if (autocomplete_instance) {
                                autocomplete_instance.destroy();
                                autocomplete_instance = null;
                            }
                        } else {
                            if (!autocomplete_instance) {
                                autocomplete_instance = update_autocomplete();
                            }
                        }
                    } else {
                        if (isMobile) {
                            if (!autocomplete_instance) {
                                autocomplete_instance = update_autocomplete();
                            }
                        } else {
                            if (autocomplete_instance) {
                                autocomplete_instance.destroy();
                                autocomplete_instance = null;
                            }
                        }
                    }
                }

                update();
                var windowWidth = $(window).width();
                window.addEventListener('resize', () => {
                    if ($(window).width() == windowWidth) return;
                    windowWidth = $(window).width();
                    update();
                }, {passive: true});
            }

            setTimeout(initAutocomplete);

            return

        });

    });
})(jQuery);